// Text shared across topic files — see apps/api/src/mastra/htsPrompts.ts.

// Used in crossCuttingNotes only (driving/online/personalConduct/substance) —
// don't also restate it in followUpTriggers, same prompt either way.
export const HTS_ISOLATED_OLD_INCIDENT_NOTE =
  "a single isolated incident more than five years ago needs no further probing and should have minimal effect on the score; a pattern, or anything within the last year, is a genuine concern and should be probed and reflected in the score";
